import { getParams } from "../../../../../../../../../src/modules/wizards/services";

export default {
    wizardType: "DB2ZOS",

    getJDBCURL: (m) =>
        "jdbc:db2://" + m.get("host") + ":" + m.get("port") + "/" + m.get("dbName"),

    getConnectionParams: async (type, model) => getParams(type, model),
};

